import PropType from "prop-types";
import React, { useState } from "react";

const defaultUrl =
    "https://us.123rf.com/450wm/yehorlisnyi/yehorlisnyi2104/yehorlisnyi210400016/167492439-no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-comin.jpg?ver=6";

const ImageLoader = ({ src = defaultUrl, alt, className }) => {
    const loadedImages = {};
    const [loaded, setLoaded] = useState(loadedImages[src]);

    const onLoad = () => {
        loadedImages[src] = true;
        setLoaded(true);
    };

    return (
        <>
            <img
                alt={alt || ""}
                className={`${className || ""} ${loaded ? "is-img-loaded" : "is-img-loading"
                    }`}
                onLoad={onLoad}
                src={src}
                onError={(e) => {
                    setLoaded(true);
                    e.target.onerror = null;
                    e.target.src = defaultUrl;
                }}
            />
        </>
    );
};

ImageLoader.defaultProps = {
    className: "image-loader",
};

ImageLoader.propTypes = {
    src: PropType.string.isRequired,
    alt: PropType.string.isRequired,
    className: PropType.string,
};

export default ImageLoader;
